import {HTMLAttributes} from 'react';
import styled from 'styled-components';
import {Typography} from '@/components/Typography';
import {Flexbox, interceptProps} from '@/styled-components';
import {palette} from '@/styles/palette';

export interface IContentProps extends HTMLAttributes<HTMLDivElement> {
  hint?: string;
  color?: string;
  typeText?: string;
  valueText?: string;
  borderColor?: string;
  hiddenPointEdge?: boolean;
}

export const CursorTextContent = ({
  hint,
  color = palette.teal100,
  typeText,
  valueText,
  borderColor = palette.gray300,
  hiddenPointEdge,
  ...props
}: IContentProps) => {
  return (
    <Root {...props} borderColor={borderColor}>
      <Flexbox>
        {!!hint?.length && (
          <Typography variant="medium12" color={color} fontWeight={700}>
            {hint}
          </Typography>
        )}
        {(!!typeText?.length || !!valueText?.length) && (
          <Flexbox>
            {!!typeText?.length && (
              <Typography
                variant="medium12"
                color={palette.textSecondary}
                fontWeight={500}
              >
                {typeText}
              </Typography>
            )}
            {!!valueText?.length && (
              <Typography
                variant="medium12"
                color={palette.textPrimary}
                fontWeight={700}
              >
                {valueText}
              </Typography>
            )}
          </Flexbox>
        )}
      </Flexbox>
      {!hiddenPointEdge && <Point color={color} />}
    </Root>
  );
};

const Point = styled('div').withConfig({
  shouldForwardProp: interceptProps(['color']),
})<{
  color: string;
}>`
  position: absolute;
  left: 1px;
  top: 1px;
  width: 0;
  height: 0;
  border-top: 8px solid ${({color}) => color};
  border-right: 8px solid transparent;
`;

const Root = styled('div').withConfig({
  shouldForwardProp: interceptProps(['borderColor']),
})<{
  borderColor: string;
}>`
  background-color: ${palette.white};
  pointer-events: none;
  padding: 4px;
  ${({borderColor}) => `border: solid 1px ${borderColor};`}
  white-space: nowrap;
  position: relative;
  & > ${Flexbox} {
    margin-right: 4px;
    & > ${Typography} {
      margin-left: 4px;
    }
    & > ${Flexbox} {
      margin-left: 2px;
      ${Typography} {
        margin-left: 2px;
      }
  }
`;
